<template>
    <list class="captive-form-list"
          :list="list"
          :infiniteId="infiniteId"
          :headers="headers"
          :loading="loading"
          @load="load">
      <template slot="default"
                slot-scope="slotProps">
        <captive-forms-list-item :item="slotProps.item"
                                   @reload="reload" />
      </template>
    </list>
  </template>
  
<script>
import List from "@components/generic/list/List.vue";
import CaptiveFormsListItem from "./item/CaptiveFormsListItem.vue"
import EventBus from "../../../../packages/event-bus";
  
export default {
    components: {
      List,
      CaptiveFormsListItem
    },
  
    data() {
      return {
        infiniteId: +new Date(),
        loading: false,       
        list: [],        
      };
    },
  
  
    props: {},

    computed: {
        headers() {
            return [
                {text: "", value: "", sortable: false, width: "5px"},
                { text: this.$t('message.generics.message.name'), value: "name", sortable: false },
                { text: this.$t('message.loginPersonalize.message.key'), value: "key", sortable: false },        
                { text: this.$t('message.loginPersonalize.message.enabledFields'), value: "enabledFields", sortable: false },        
                { text: this.$t('message.loginPersonalize.message.integration'), value: "enabledFields", sortable: false },        
                { text: this.$t('message.generics.message.creationDate'), value: "creationDate", sortable: false },        
                { text: "", value: "", sortable: false },        
            ]
        },
        filters() {
            return this.$store.state.trackers.filters.search;
        },
    },
  
    methods: {      
      emitReload() {
        this.$emit("reload");
      },
      async load($state) {
        try {
            this.loading = true;

            const loginTypes = await this.$api.core.loginTypes.list();

            this.list = loginTypes;

            this.loading = false;

            $state.complete();
        } catch (e) {
            console.log(e)
        }

      },
      reload() {
        this.infiniteId++;
      },
      
    },

    mounted() {
      EventBus.$on("CAPTIVE_FORM_ADDED", this.reload);
    },

    beforeDestroy() {
      EventBus.$off("CAPTIVE_FORM_ADDED", this.reload);
    },
    
    
  };
</script>
  
<style lang="scss" scoped>
  .captive-form-list {
    ::v-deep .v-table__overflow {
      overflow: visible;
    }
  }
</style>